import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { extensionGroupOptionActions } from './extension-group-option.actions';
import { extensionGroupOptionSelectors } from './extension-group-option.reducer';

@Injectable({ providedIn: 'root' })
export class ExtensionGroupOptionEffects {
   defaultFields: string[] = ['extensionGroupId', 'name', 'extensionGroupExtensions.extensionId'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionGroupOptionSelectors.selectState,
      'extensionGroups',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionGroupOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
